/**
 * created by xcc on 2021/10/21
 * 新媒体新增组件
 */
import React from 'react';
import PropTypes from 'prop-types';
import {Modal, Row, Col, Upload, Icon, Input, Select, Button, Form, Tooltip, Progress, DatePicker} from "antd";
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import Scrollbars from "react-custom-scrollbars";
import {PIC_TYPE_PDF} from "../../../../constants";
import Activiti from "./NewMediaManageActivity";
import {formatDate, uuid} from "../../../../utils";
import $ from "jquery";
import {
    addNewMedia,
    checkName,
    checkDouyinLink,
    getActHistory,
    updateNewMediaStatusName,
    updateNewMedia,
    batchAddTemp,
    batchAddSimpleAdd,
    batchAddUpdateSimple,
    deleteNewMediaById, getOverTask, batchAddSave, cancelExport, getCurrentUser, getNewMediaById
} from "../../actions/newMediaManage";
import UpdateAndFlowRecord from "./UpdateAndFlowRecord";
import {getNewMediaFields} from "../../actions/platformMaintenance";
import moment from 'moment';
import BaseComponent from "../../../../base/BaseComponent";

const {Option} = Select;
const {TextArea} = Input;
const {confirm} = Modal;


class NewAddMedia extends BaseComponent {
    static defaultProps = {}
    static propTypes = {}

    textareaModalTitle = '备注';
    callbackType = '';
    callback = () => {
    };

    constructor(props) {
        super(props);
        this.state = {
            history: require("history").createHashHistory(),
            loading: false,
            visible: false,
            id: null,  //媒体id
            _id: "",  //媒体_id
            code: "",  //媒体code
            logo: "",  //媒体logo
            newMediaTypeId: undefined,  //媒体平台
            name: "",  //媒体名称
            mainDeptId: undefined,  //主责单位
            selectSearchValue: "",
            status: "未备案",  //备案状态
            recordTable: {},  //备案表
            uuid: "",
            createById: "",
            auditRecordData: [],  //审核记录数据
            actHistoryData: [], //流程历史
            createByName: "",
            createDeptIds: [],
            createTime: "",
            updateTime: "",
            lastActiveTime: "", //最近活跃
            imgPath: "", //预览图片路径
            viewImgVisible: false,
            //流程添加备注
            textareaModalVisible: false,
            auditRemarks: "",
            statusName: "", //媒体状态,
            isUpdateInfo: false,
            currentMedia: {},
            mediaInfo: {},
            processType: 0,  //流程类型
            buttons: [],
            uuid2auditData: {},
            percent: 0,
            step: 1,
            fieldList: [],  //自定义字段数组
            auditSuccessVisible: false,  //批量审核成功弹窗
            auditSuccessContent: "",
            isShowRemarks: true,
            key: uuid(),
            processTypeName: "",
            activityOldData: {},
            activityRemark: ""
        };
    }

    componentWillUnmount() {

    }

    componentWillMount() {

    }

    componentDidMount() {
        this.props.onRef(this);
    }

    init(item, callback, processCallback) {
        if (item) {
            this.state.isUpdateInfo = false;
            if (this.props.showCurrentPageType === "mainPage" && ((item.statusName === "已备案" && item.status === "已备案") || item.statusName === "更新审核不通过" || item.statusName === "删除审核不通过" || item.statusName === "注销审核不通过" || (item.status === "已备案" && item.statusName === "返回申请人"))) {
                this.state.isUpdateInfo = true;
            }
            this.state.activityOldData = {};
            this.setState({
                id: item.id,  //媒体id
                _id: item._id,  //媒体_id
                code: item.code, //媒体code
                logo: item.logo,  //媒体logo
                newMediaTypeId: item.newMediaTypeId,  //媒体平台
                name: item.name,  //媒体名称
                mainDeptId: item.mainDeptId,  //主责单位
                status: item.status,  //备案状态
                recordTable: item.recordTable ? JSON.parse(item.recordTable) : {},  //备案表
                statusName: item.statusName,  //媒体状态
                uuid: item.uuid, //uuid
                createById: item.createById,  //创建人
                currentMedia: item,  //当前媒体
                processType: item.processType, //流程类型
                createByName: item.createByName, //创建人名称
                createDeptIds: item.createDeptIds,  //创建人部门ids
                createTime: item.createTime,  //创建时间
                updateTime: item.updateTime,  //更新时间
                lastActiveTime: item.lastActiveTime,  //最近活跃
                fieldList: item.ext, //自定义字段数据
                mediaInfo: item,
            });
            //初始化流程
            this.initNewMediaAct(item, callback, processCallback);
            this.getNewMediaFields(item);  //获取最新的维护字段
        } else {
            //初始化流程
            this.initNewMediaAct({}, callback, processCallback);
        }
    }

    //保存媒体
    saveMedia(activiti, callback) {
        //批量审核时赋值
        let dataForm;
        let newFieldList = [];
        let fieldList = this.state.fieldList;
        if (this.props.showCurrentPageType === "batchPage" && !this.props.simpleAddOrEdit) {
            let extObj = {};
            this.state.fieldList.forEach(item => {
                extObj[item.id] = item.value;
            })
            dataForm = {
                name: this.state.name,
                logo: this.state.logo,
                newMediaTypeId: this.state.newMediaTypeId,
                mainDeptId: this.state.mainDeptId,
                ext: this.state.fieldList,
                ...extObj
            }
        } else {
            dataForm = this.props.form.getFieldsValue();
            dataForm.logo = this.state.logo;
            if (fieldList && fieldList.length > 0) {
                fieldList.forEach(item => {
                    if (item.status && dataForm[item.id]) {
                        //赋值
                        item.value = dataForm[item.id];
                        let val = dataForm[item.id];
                        //类型为时间选择器
                        if (item.fieldType === 5) {
                            if (val) {
                                val = dataForm[item.id].valueOf();
                            } else {
                                val = null;
                            }
                        }
                        newFieldList.push({
                            newMediaFieldDefineId: item.id,
                            value: val
                        });
                    }
                });
            }
        }
        //表单校验
        if (!dataForm.name) {
            message.warn("请输入媒体名称！");
            window.loading.hide();
            return;
        }
        if (!dataForm.newMediaTypeId) {
            message.warn("请选择媒体平台！");
            window.loading.hide();
            return;
        }
        if (!dataForm.mainDeptId) {
            message.warn("请选择主责单位！");
            window.loading.hide();
            return;
        }
        //维护字段校验
        let reg = /^[\d-]+$/;
        for (var i = 0; i < fieldList.length; i++) {
            let fieldListItem = fieldList[i];
            let dbFieldName = fieldListItem.dbFieldName;
            if (fieldListItem.status && fieldListItem.required === 0 && dbFieldName === "contact" && dataForm[fieldListItem.id] && (!reg.test(dataForm[fieldListItem.id]))) {
                message.error("联系电话格式不正确！");
                window.loading.hide();
                return;
            }
            if (fieldListItem.status && fieldListItem.required === 0 && !dataForm[fieldListItem.id]) {
                let fieldName = fieldListItem.fieldName;
                let fieldType = fieldListItem.fieldType;
                let tipText = "请输入" + fieldName;
                if (fieldType === 3 || fieldType === 4 || fieldType === 5) {
                    tipText = "请选择" + fieldName;
                }
                message.warn(tipText);
                window.loading.hide();
                return;
            }
        }
        this.saveData(activiti, callback, dataForm, newFieldList);
    }

    saveData(activiti, callback, dataForm, newFieldList) {
        let body = {
            "logo": dataForm.logo,
            "newMediaTypeId": dataForm.newMediaTypeId,
            "name": dataForm.name,
            "mainDeptId": dataForm.mainDeptId,
            "recordTable": this.state.recordTable ? JSON.stringify(this.state.recordTable) : "",
            "status": this.state.status,
            "statusName": this.state.statusName,
            "uuid": this.state.uuid,
            "processType": this.state.processType,
            "createByName": this.state.createByName,
            "createDeptIds": this.state.createDeptIds,
            "createTime": this.state.createTime,
            "updateTime": this.state.updateTime,
            "ext": newFieldList && newFieldList.length > 0 ? newFieldList : dataForm.ext
        };
        if (this.state.id !== undefined && this.state.id !== null) {
            body.id = this.state.id;
        }
        if (this.state._id) {
            body._id = this.state._id;
        }
        if (this.state.code) {
            body.code = this.state.code;
        }
        //新增媒体
        if (this.state.id !== undefined && this.state.id !== null) {
            if (this.props.batchTitle === "批量新增") {
                let params = {
                    newMediaIds: this.state.id
                }
                batchAddSave(params, (data) => {
                    if (data && data.length > 0) {
                        if (callback) {
                            this.state.id = data[0].id;
                            data[0].processTypeName = this.state.processTypeName;
                            callback(data[0]);
                        } else {
                            message.success("暂存成功");
                            activiti.submitOK();
                        }
                        this.updateProcessAndData(data[0]);
                    } else {
                        message.error('新增失败！');
                        if (callback) {
                            callback(false);
                        }
                    }
                })
            } else {
                // 如果不是流程按钮  自己调loading
                if (!callback) {
                    window.loading.show();
                }
                updateNewMedia(body, (data) => {
                    // 如果不是流程按钮  自己调loading
                    if (!callback) {
                        window.loading.hide();
                    }
                    if (data) {
                        if (callback) {
                            this.state.id = data.id;
                            getNewMediaById({id: data.id}, (res) => {
                                res.processTypeName = this.state.processTypeName;
                                $.extend(true, body, res);  //将Data深度合并到body上
                                callback(body);
                            })
                        } else {
                            message.success("暂存成功");
                            if (this.props.batchData) {
                                this.state.visible = false;
                                this.props.simpleAddOrEditChange();
                                this.revert();
                                this.props.getNeedAuditMedia((batchData) => {
                                    if (batchData.length > 0) {
                                        this.props.initProcessOperate(batchData);
                                    }
                                })
                            } else {
                                activiti.submitOK();
                            }
                        }
                        this.updateProcessAndData(data);
                    } else {
                        message.error('修改失败！');
                        if (callback) {
                            callback(false);
                        }
                    }
                }, {
                    info: (info) => {
                        message.error(info);
                        if (!callback) {
                            window.loading.hide();
                        }
                        if (callback) {
                            callback(false);
                        }
                    }
                })
            }
        } else {
            // 如果不是流程按钮  自己调loading
            if (!callback) {
                window.loading.show();
            }
            addNewMedia(body, (data) => {
                // 如果不是流程按钮  自己调loading
                if (!callback) {
                    window.loading.hide();
                }
                if (data) {
                    if (callback) {
                        this.state.id = data.id;
                        $.extend(true, body, data);  //将Data深度合并到body上
                        callback(body);
                    } else {
                        message.success("暂存成功");
                        activiti.submitOK();
                    }
                    this.updateProcessAndData(data);
                } else {
                    message.error('新增失败！');
                    if (callback) {
                        callback(false);
                    }
                }
            }, {
                info: (info) => {
                    message.error(info);
                    if (!callback) {
                        window.loading.hide();
                    }
                    if (callback) {
                        callback(false);
                    }
                }
            })
        }
    }

    // 更新流程稿件
    updateProcessAndData(body) {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            body: {
                title: body?.name,
                bizKey: body?.id,
                data: body,
            },
            callBack: (res) => {

            }
        })
    };

    //媒体操作侧流程初始化
    initNewMediaAct(currentMedia, callback, processCallback) {
        //新的媒体操作流程适配
        var canDo = true;
        let that = this;
        //新的媒体操作
        let activitiConfs = [];

        //确定是走新增流程，还是删除修改流程
        let treeCode = "activitiTreeRoot-media_operate_add";
        if (currentMedia.status === "已备案" || currentMedia.statusName === "更新审核不通过" || currentMedia.statusName === "注销审核不通过" || currentMedia.statusName === "删除审核不通过") {
            treeCode = "activitiTreeRoot-media_operate_update";
        }
        let baselConf = {
            activitiTypeEnum: "OTHER",
            type: "OTHER",
            treeCode: treeCode,
        }

        let againFlag = false;
        againFlag = (currentMedia.statusName === "" || currentMedia.statusName === "已备案" || currentMedia.statusName === "草稿" || currentMedia.statusName === "新增审核不通过" || currentMedia.statusName === "更新审核不通过" || currentMedia.statusName === "注销审核不通过" || currentMedia.statusName === "删除审核不通过");
        activitiConfs.push(baselConf);
        Activiti.createActivit({
                uuid: currentMedia && currentMedia.uuid ? currentMedia.uuid : "",   //主键id
                oldUuid: againFlag ? currentMedia.uuid : null,
                pojoName: "mediaAudit",
                userAccount: window.top.currentUser.account,
                showBtnFlag: true,
                activitiConf: activitiConfs,
                againFlag: againFlag,
                showAfterFuns: {   //按钮加载前置js

                    //审核不通过才显示删除按钮
                    hidenDeleteBtn: function (item, call) {
                        //不允许编辑
                        if (currentMedia.statusName && currentMedia.statusName.indexOf("审核不通过") > -1 && currentMedia.createById === window.top.currentUser.id) {
                            call({code: 1});
                        }
                    },
                    hidenBtn: function (item, call) {
                        //不允许编辑
                        if (currentMedia.createById && currentMedia.createById !== window.top.currentUser.id) {
                            call({code: 0});
                        } else {
                            call({code: 1});
                        }
                    },
                    // callBackBtnShow: function (item, call) {
                    //     //不允许编辑
                    //     call({code: 0, log: "xxxx"});          //此方法用来隐藏撤回按钮
                    // }
                },
                render: function () {

                },
                otherJs: {

                    setAllUser: function (activiti, buttonConf, call) {
                        activiti.getUser(activiti.auditorMapTemp, activiti, function (res) {
                            activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = res
                        })
                    },

                    /**
                     * 修改完成后直接提交给返回的人 不经过中间审核
                     * @param activiti
                     * @param buttonConf
                     * @param call
                     */
                    callAgent: function (activiti, buttonConf, call) {
                        let uuid = activiti.options.uuid;
                        getActHistory({bizKey: uuid}, (data) => {
                            let historyList = data;
                            if (historyList && historyList.length > 1 && historyList[0].candidateInfo && historyList[0].candidateInfo.length) {
                                var callBackHistory = historyList[0];
                                activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                                    id: callBackHistory.operatorUserInfo.userId,
                                    name: callBackHistory.operatorName,
                                    deptId:  callBackHistory.operatorUserInfo.deptId,
                                }];
                                call({code: 1, log: "查询到返回者为：" + callBackHistory.candidateNames[0]});
                            } else {
                                call({code: -1, msg: "未查询到返回者！"})
                            }
                        })
                    },

                    confirmOperate: function (activiti, buttonConf, call) {
                        if (!that.props.batchData || that.props.batchData.length == 0) {
                            let msgContent;
                            if (buttonConf.btnName.indexOf("注销") > -1) {
                                msgContent = '注销后无法恢复，请问是否注销？';
                            } else if (buttonConf.btnName.indexOf("删除") > -1) {
                                msgContent = '账号删除之后所有数据都会删除，请问还要继续吗？';
                            } else {
                                msgContent = buttonConf.btnName + '信息后需重新审核，\n' +
                                    '\n' +
                                    '请问还要继续吗？'
                            }
                            confirm({
                                title: msgContent,
                                okText: '确定',
                                cancelText: '取消',
                                onOk() {
                                    call({code: 1, log: "confirmOperate"});
                                },
                                onCancel() {
                                    that.setState({})
                                },
                            })
                        } else {
                            call({code: 1, log: "batch  confirmOperate"});
                        }
                    },
                    confirmDeleteOperate: function (activiti, buttonConf, call) {
                        if (!that.props.batchData || that.props.batchData.length == 0) {
                            confirm({
                                title: '提示',
                                content: '确认是否要删除此数据',
                                okText: '确定',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    call({code: 1, log: "confirmOperate"});
                                },
                                onCancel() {
                                    that.setState({})
                                },
                            })
                        } else {
                            call({code: 1, log: "confirmOperate"});
                        }
                    },
                    callBackSubmiiter: function (activiti, buttonConf, call) {
                        that.callBackSubmiiter.call(that, activiti, buttonConf, call);
                        call({code: 1, log: "callBackSubmiiter"});
                    },
                    callBackProcessType: function (activiti, buttonConf, call) {
                        if (buttonConf.btnName && buttonConf.btnName.indexOf("更新") > -1) {
                            that.state.processTypeName = "更新";
                            call({code: 1, log: "callBackProcessType"});
                        } else if (buttonConf.btnName && buttonConf.btnName.indexOf("注销") > -1) {
                            that.state.processTypeName = "注销";
                            call({code: 1, log: "callBackProcessType"});
                        } else if (buttonConf.btnName && buttonConf.btnName.indexOf("删除") > -1) {
                            that.state.processTypeName = "删除";
                            call({code: 1, log: "callBackProcessType"});
                        }
                    },
                    deleteMedia: function (activiti, buttonConf, call) {
                        call({code: 1, log: "deleteMedia"});
                    },
                    okUpdateData: function (activiti, buttonConf, call) {
                        //processType流程类型设置为1
                        that.state.processType = 1;
                        call({code: 1, log: "okUpdateData"});
                    },
                    auditDelete: function (activiti, buttonConf, call) {
                        if (buttonConf.btnName && buttonConf.btnName.indexOf("注销") > -1) {
                            that.state.processType = 2;
                        } else {
                            that.state.processType = 3;
                        }
                        call({code: 1, log: "auditDelete"});
                    },
                    revertMediaData: function (activiti, buttonConf, call) {
                        activiti.getHistory(function (data) {
                            let oldData = {};
                            if (data && data.length) {
                                let historyData = data;
                                for (var i = 0; i < historyData.length; i++) {
                                    if (historyData[i].taskName === '已备案') {
                                        oldData = historyData[i].processData && historyData[i].processData.data;
                                        break;
                                    }
                                }
                            }
                            if (oldData) {
                                that.state.activityOldData = oldData;
                            }
                            call({code: 1, log: "revertMediaData"});
                        });
                    },
                    callActRevert: function (activiti, buttonConf, call) {
                        activiti.terminate(function (res) {
                            if (res === true) {
                                activiti.options.statusNameTemp = "草稿";
                                activiti.endFunction(activiti, function (res) {
                                    if (res.status === true) {
                                        message.success("流程已撤回，该媒体变为草稿状态", 1);
                                        activiti.submitOK();
                                    }
                                })
                            }
                        });
                    }
                },
                success: function (activiti) {   //对象创建成功回调
                    //新旧流程记录串起来
                    if (againFlag && currentMedia && currentMedia.uuid) {
                        activiti.options.oldUuid = currentMedia.uuid;
                    }
                    //重写推进前保存方法
                    activiti.afterSave = function (activiti, call) {
                        if (that.state.processType === -1 && (activiti.options.statusNameTemp === '已备案' || activiti.options.statusNameTemp === '删除媒体')) {
                            that.delete.call(that, activiti, call);
                        } else {
                            that.saveMedia(activiti, call);
                        }
                    }
                    activiti.getActivitiKey = function (activitiConf, call) {
                        activiti.post("/dynamic/cm-sites-sys/activitiBindTree/getByconf", {"treeCode": activitiConf[0].treeCode}, function (res) {
                            if (res && res.activitiApp && res.activitiApp.key && (!Object.keys(currentMedia).length || (currentMedia && window.top.currentUser.id === currentMedia.createById))) {
                                call(res.activitiApp.key);
                            } else {
                                call(false);
                            }
                        })
                    }

                    //重写创建按钮的方法
                    activiti.renderButton = function (buttons = [], call) {
                        that.renderButtons(buttons, call, activiti, activitiConfs, callback)
                    }

                    //填写备注信息
                    activiti.getText = function (data, type, callback) {
                        that.getText(data, type, callback, activiti)
                    }

                    activiti.load = {
                        start: function () {
                            window.loading.show();
                        },
                        end: function () {
                            window.loading.hide();
                        }
                    }
                    activiti.getChoose = function (data, type, callback) {
                        that.getChoose(data, type, callback, activiti);

                    }
                    activiti.endFunction = function (activiti, call) {  //流程推进后的回调一般用作推进后修改状态
                        let statusName = activiti.options.statusNameTemp;
                        let params = {
                            id: that.state.id,
                            statusName: encodeURI(statusName)
                        };
                        updateNewMediaStatusName(params, (data) => {
                            if (data) {
                                call({status: true, msg: data.mszg});
                                if (statusName === "删除媒体") {
                                    let body = {
                                        id: params.id
                                    }
                                    deleteNewMediaById(body, (data) => {})
                                }
                            } else {
                                call({status: false, msg: "流程推进后状态修改失败。"});
                            }
                        });
                    }
                    activiti.error = function (res) {     //流程推进成功后的提示点击确定的回调，一般用来关闭窗口或刷新
                        let msg = res.msg;
                        if(typeof res === "string"){
                            msg = res;
                        }
                        message.error(msg, 1);
                        if (processCallback) {
                            processCallback()
                        }
                    }
                    activiti.successMsg = function (res, call) {
                        if (res) {
                            message.success("流程提交成功", 1);
                            call();
                        }
                    }
                    activiti.submitOK = (call) => {
                        //关闭窗口
                        if (processCallback) {
                            processCallback()
                        }
                        that.state.visible = false;
                        that.props.getNeedAuditMedia();
                        that.revert();
                    }
                    activiti.showRemarks = function (remark) {
                        if (that.props.showCurrentPageType === "mainPage" && that.state.isShowRemarks === true) {
                            that.setState({
                                activityRemark: remark
                            })
                        }
                    };

                },
            }
            , function (activiti) {
                //流程初始化完成之后的回调
                if (this.buttonList && this.buttonList.length > 0 && canDo) {

                }
                if (that.state.statusName === "草稿" || !that.state.statusName) {
                    return;
                }
                this.getHistory(function (history) {
                    that.state.actHistoryData = history;
                })
            });
    }

    //界面回退到原始的数据；
    revertOldData(data) {
        if (data.logo) {
            this.state.logo = data.logo;//媒体logo
        } else {
            this.props.mediaPlatform.forEach(item => {
                if (item.id === data.newMediaTypeId) {
                    this.state.logo = item.logoPath ? item.logoPath : "";
                }
            })
        }
        this.state.id = data.id;
        this.state._id = data._id;
        this.state.uuid = data.uuid;
        this.state.name = data.name;//媒体名称
        this.state.newMediaTypeId = data.newMediaTypeId;//媒体平台
        this.state.mainDeptId = data.mainDeptId;//主责单位
        this.state.recordTable = data.recordTable ? JSON.parse(data.recordTable) : {};//备案表
        this.state.fieldList = data.ext;
    }

    //添加备注信息
    getText = (data, type, callback, activiti) => {
        if (data) {
            this.textareaModalTitle = data.title;
        }
        this.callbackType = type;
        this.callback = callback;
        this.setState({
            textareaModalVisible: true
        });
    }

    textareaHandleOk = () => {
        let auditRemarks = this.state.auditRemarks;
        if (!auditRemarks) {
            message.warn("请输入备注！");
            return;
        }
        //把数据恢复到原始的样子；
        if (Object.keys(this.state.activityOldData).length) {
            this.revertOldData(this.state.activityOldData);
        }
        let callbackValue = {};
        callbackValue.remarks = auditRemarks;
        callbackValue.type = this.callbackType;
        if (this.props.batchData) {
            this.state.stepVisible = true;
        }
        this.setState({
            textareaModalVisible: false,
            visible: false,
            auditRemarks: ''
        }, () => {
            this.callback(callbackValue);
        })
    };

    //删除媒体
    delete = (activiti, callback) => {
        if (this.props.batchData && this.props.batchData.length === 0) {
            message.warn('请先选择需要批量处理的数据！');
            window.loading.hide();
            return;
        }
        let item = this.state.mediaInfo;
        let body = {
            id: item.id
        }
        deleteNewMediaById(body, (data) => {
            let body = this.state.mediaInfo;
            if (data) {
                if (callback) {
                    callback(body);
                } else {
                    activiti.success({msg: "操作成功！", state: true}, activiti.submitOK);
                }
            } else {
                message.error('无法删除！');
            }
        })
    }

    isBtnClick = false;

    renderButtons = (actButonsdata, call, activiti, activitiConfs, callback) => {

        let myMedia = this;
        if (!actButonsdata || actButonsdata.length == 0) {
            actButonsdata = [];
        }

        let that = activiti;
        var actButtons = actButonsdata.map((item, index) => {
            //前置js， 控制按钮的显隐
            let hideStyle = {
                display: 'inline-block'
            }
            let isDisabled = false;
            if (item.document && item.document.lineJavaScript && item.document.lineJavaScript.afterButtonShow && that.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]) {
                hideStyle = {
                    display: 'none'
                }
                var func = eval(that.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]);
                new func(item, function (res) {
                    if (res.code > 0) {
                        // that.buttonShow(btn);
                        hideStyle = {
                            display: 'inline-block'
                        }
                    } else if (res.code == 0) {
                        activiti.log("状态：0 ，" + item.document.lineJavaScript.afterButtonShow + ":" + res.log || res.msg);
                    } else {
                        activiti.error(item.document.lineJavaScript.afterButtonShow + ":" + res.log)
                    }
                });
            }

            //点击修改信息时候禁用更新和删除流程按钮
            if (myMedia.props.showCurrentPageType === "mainPage" && !myMedia.state.isUpdateInfo && item.btnName && (item.btnName.indexOf("删除") > -1 || item.btnName.indexOf("注销") > -1)) {
                isDisabled = true;
            }

            //需要修改信息时候隐藏更新流程按钮
            if (myMedia.state.isUpdateInfo && item.btnName && item.btnName.indexOf("更新") > -1) {
                hideStyle = {
                    display: 'none'
                }
            }

            //不是自己创建的媒体不能走更新、注销和删除流程
            if (window.top.currentUser.id !== this.state.createById && item.btnName && (item.btnName.indexOf("更新") > -1 || item.btnName.indexOf("删除") > -1 || item.btnName.indexOf("注销") > -1)) {
                hideStyle = {
                    display: 'none'
                }
            }

            //如果是批量单独添加、编辑、查看，隐藏流程按钮
            if (myMedia.props.simpleAddOrEdit) {
                hideStyle = {
                    display: 'none'
                }
            }

            //流程需要执行的其他js
            var args = [];
            if (item.document.lineJavaScript.otherJs && item.document.lineJavaScript.otherJs.split(",").length > 0) {
                var funArray = item.document.lineJavaScript.otherJs.split(",");
                $.each(funArray, function fun(i, it) {
                    var funtemp = function () {
                        var callback = Activiti.util.getCallbackFn.call(funtemp);
                        var func = that.options.otherJs[funArray[i]];
                        if (func) {
                            func.call(that, that, item, function (res) {
                                if (res) {
                                    callback.call(that, item)
                                } else {
                                    that.error(res || "执行出错！");
                                }
                            })
                        } else {
                            that.error("未找到前置js：" + funArray[i] + ",请清除浏览器缓存重试。如清理缓存后问题依然存在，请联系管理员。")
                        }
                    }
                    args.push(funtemp);
                })
            }
            args.push(function () {
                that.buttonClick.call(that, item)
            });
            const hideStyleOk = hideStyle;
            return <div key={uuid()} className="button_view" style={{...hideStyleOk}}>
                <Button
                    disabled={isDisabled}
                    type={(item.btnName.indexOf("删除") > -1 || item.btnName.indexOf("注销") > -1 || item.btnName.indexOf("返回") > -1 || item.btnName.indexOf("审核不通过") > -1) ? "default" : "primary"}
                    style={{marginRight: "10px"}} onClick={() => {
                    if(!that.isBtnClick){
                        that.isBtnClick = true;
                        // 执行操作
                        that.options.item = item;
                        //清空辅助参数
                        activiti.auditorMapTemp = item.document.lineJavaScript.auditorMap;
                        activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [];

                        //批量审核和单个审核
                        if (myMedia.props.batchData) {
                            if (myMedia.props.batchData.length > 0) {
                                myMedia.batchTask.call(that, that.options.item, myMedia);
                            } else {
                                message.warn("请先选择需要处理的数据！");
                            }
                        } else {
                            Activiti.util.simpleChainedFn.apply(that, args);
                        }
                        setTimeout(() => {
                            that.isBtnClick = false;
                        }, 1000);
                    }
                }}>{item.btnName || item.name}</Button>
            </div>
        });

        if (myMedia.props.simpleAddOrEdit) {
            //渲染批量转交、批量审核、批量添加单独更新按钮
            myMedia.renderPushBtn(activiti, myMedia, actButtons);
        } else {
            //单个媒体暂存
            if (myMedia.props.showCurrentPageType === "mainPage" && ((myMedia.state.id && window.top.currentUser.id === this.state.createById && myMedia.state.statusName === "草稿") || !myMedia.state.id)) {
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        myMedia.saveMedia(activiti);
                    }}>{'暂存'}</Button>
                </div>);
            }
            if (myMedia.props.showCurrentPageType === "mainPage" && (!myMedia.props.batchData || myMedia.props.batchData.length === 0)) {
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        myMedia.setState({visible: false})
                    }}>{myMedia.state.id ? "关闭" : '取消'}</Button>
                </div>);
            }
            //批量新增暂存
            if (myMedia.props.showCurrentPageType === "batchPage" && myMedia.props.batchTitle === "批量新增") {
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        myMedia.batchAddTemp();
                    }}>{'暂存'}</Button>
                </div>);
            }
            if (myMedia.props.showCurrentPageType === "batchPage") {
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        myMedia.props.cancelExport();
                    }}>{'返回'}</Button>
                </div>);
            }
            if (window.top.currentUser.id === this.state.createById && myMedia.state.id && myMedia.state.processType === 0 && (myMedia.state.statusName === "新增审核不通过" || myMedia.state.statusName === "草稿")) {
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        this.deleteCurrentMedia(myMedia.props.batchData);
                    }}>{'删除'}</Button>
                </div>);
            }
            if (myMedia.props.showCurrentPageType === "mainPage" && myMedia.state.id) {
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        myMedia.auditRecordData();
                    }}>{'审核记录'}</Button>
                </div>);
            }

            if (window.top.currentUser.id === this.state.createById && this.props.showCurrentPageType === "mainPage"
                && this.state.id && ((myMedia.state.statusName === "已备案" && myMedia.state.status === "已备案") || myMedia.state.statusName === "更新审核不通过" || myMedia.state.statusName === "注销审核不通过" || myMedia.state.statusName === "删除审核不通过" || (myMedia.state.status === "已备案" && myMedia.state.statusName === "返回申请人"))) {
                if (!myMedia.state.isUpdateInfo) {
                    actButtons.unshift(<div key={uuid()} id={"updateButton"} className="button_view"
                                            style={{display: 'inline-block'}}>
                        <Button
                            type={"default"}
                            style={{marginRight: "10px"}}
                            onClick={() => this.cancelUpdateInfo()}>{'取消修改'}</Button>
                        <style>{`#updateButton button + button {margin-left: 0px !important;}`}</style>
                    </div>)
                }else {
                    actButtons.push(<div key={uuid()} id={"updateButton"} className="button_view"
                                         style={{display: 'inline-block'}}>
                        <Button
                            type={"primary"}
                            style={{marginRight: "10px"}}
                            onClick={() => {
                                this.updateInfo();
                            }}>{'修改信息'}</Button>
                        <style>{`#updateButton button + button {margin-left: 0px !important;}`}</style>
                    </div>)
                }
            }
        }

        if (callback) {
            callback(actButtons)
        }

        this.setState({
            buttons: actButtons,
        })
    }

    deleteCurrentMedia(batchData) {
        let idArr = [];
        if (this.props.showCurrentPageType === "mainPage") {
            idArr.push(this.state.id);
        } else {
            batchData && batchData.length > 0 && batchData.forEach(item => {
                if (item.checked) {
                    idArr.push(item.id);
                }
            })
        }
        Modal.confirm({
            title: '请注意，删除操作不可逆，你确定要删除吗？',
            centered: 'centered',
            okText: "确定",
            okCancel: "取消",

            onOk: () => {
                let body = {
                    id: idArr
                }
                deleteNewMediaById(body, (data) => {
                    if (data) {
                        message.success("删除成功");
                    } else {
                        message.error("删除失败！");
                    }
                    if (this.props.showCurrentPageType === "mainPage") {
                        this.state.visible = false;
                        this.props.getNeedAuditMedia();
                    } else {
                        // this.props.checkedChanage();
                        this.props.getNeedAuditMedia((batchData) => {
                            if (batchData.length > 0) {
                                this.props.initProcessOperate(batchData);
                            }
                        });
                    }
                })
            }
        })
    }

    batchAddTemp() {
        let flag = false;
        //校验
        this.props.batchData.forEach((item, pIndex) => {
            if (!item.mainDeptId || !item.name) {
                flag = true;
                if (flag) {
                    message.warn("请检查必填项！");
                    return false;
                }
            }
            //维护字段校验
            this.getNewMediaFields(item, (fieldList) => {
                fieldList.forEach((i, index) => {
                    if (i.status && i.required === 0 && !item.ext.length) {
                        flag = true;
                        if (flag) {
                            message.warn("请检查必填项！");
                            return false;
                        }
                    }
                    //第一层循环的最后一个  和  第二层循环的最后一个  都成立才往下走
                    if ((index === fieldList.length - 1) && pIndex === this.props.batchData.length - 1 && !flag) {
                        let newMediaIds = [];
                        //循环保存每一条数据
                        this.props.batchData.forEach(item => {
                            newMediaIds.push(item.id);
                            let body = {...item};
                            batchAddUpdateSimple(body, (data) => {
                                if (data.length > 0) {
                                    this.props.batchSaveAfterEdit();
                                }
                            })
                        })
                        //暂存所有
                        batchAddTemp({newMediaIds}, (data) => {
                            if (data.length > 0) {
                                message.success("批量新增暂存成功");
                                this.props.batchSaveAfterEdit();
                                this.setState({})
                            } else {
                                message.error("批量新增暂存失败！");
                            }
                        })
                    }
                })
            });
        })
    }

    renderPushBtn = (activiti, myMedia, actButtons) => {
        if (myMedia.props.showCurrentPageType === "batchPage") {
            if (myMedia.props.batchTitle === "批量新增") {
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        myMedia.batchAddSimpleAddOrEdit();
                    }}>{'确定'}</Button>
                </div>);
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        myMedia.props.simpleAddOrEditChange()
                        this.setState({visible: false});
                    }}>{'取消'}</Button>
                </div>);
            }
            if (myMedia.props.batchTitle === "批量新增审核" || myMedia.props.batchTitle === "批量更新审核" || myMedia.props.batchTitle === "批量注销审核" || myMedia.props.batchTitle === "批量删除审核") {
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        myMedia.props.simpleAddOrEditChange();
                        this.setState({visible: false})
                    }}>{'取消'}</Button>
                </div>);
                if (myMedia.props.batchSimpleEdit) {
                    actButtons.unshift(<div key={uuid()} className="button_viewRecord"
                                            style={{display: 'inline-block'}}>
                        <Button className={"customBtn"}
                                style={{marginRight: "10px"}} onClick={() => {
                            this.saveMedia(activiti);
                        }}>{'保存'}</Button>
                    </div>);
                }
            }
            if (myMedia.props.batchTitle === "批量转交") {
                actButtons.unshift(<div key={uuid()} className="button_viewRecord" style={{display: 'inline-block'}}>
                    <Button className={"customBtn"}
                            style={{marginRight: "10px"}} onClick={() => {
                        myMedia.props.simpleAddOrEditChange()
                        this.setState({visible: false})
                    }}>{'关闭'}</Button>
                </div>);
            }
        }
    }

    batchAddSimpleAddOrEdit() {
        let dataForm = this.props.form.getFieldsValue();
        let fieldList = this.state.fieldList;
        if (!dataForm.name) {
            message.warn("请输入媒体名称！");
            return;
        }
        if (!dataForm.newMediaTypeId) {
            message.warn("请选择媒体平台！");
            return;
        }
        if (!dataForm.mainDeptId) {
            message.warn("请选择主责单位！");
            return;
        }
        //维护字段校验
        let reg = /^[\d-]+$/;
        for (var i = 0; i < fieldList.length; i++) {
            let fieldListItem = fieldList[i];
            let dbFieldName = fieldListItem.dbFieldName;
            if (fieldListItem.status && fieldListItem.required === 0 && dbFieldName === "contact" && dataForm[fieldListItem.id] && (!reg.test(dataForm[fieldListItem.id]))) {
                message.error("联系电话格式不正确！");
                return;
            }
            if (fieldListItem.status && fieldListItem.required === 0 && !dataForm[fieldListItem.id]) {
                let fieldName = fieldListItem.fieldName;
                let fieldType = fieldListItem.fieldType;
                let tipText = "请输入" + fieldName;
                if (fieldType === 3 || fieldType === 4 || fieldType === 5) {
                    tipText = "请选择" + fieldName;
                }
                message.warn(tipText);
                return;
            }
        }
        let newFieldList = [];
        if (fieldList && fieldList.length > 0) {
            fieldList.forEach(item => {
                item.value = dataForm[item.id];
                let val = dataForm[item.id];
                //类型为时间选择器
                if (item.fieldType === 5) {
                    if (val) {
                        val = dataForm[item.id].valueOf();
                    } else {
                        val = null;
                    }
                }
                newFieldList.push({
                    newMediaFieldDefineId: item.id,
                    value: val
                });
            });
        }
        let body = {
            "logo": dataForm.logo,
            "newMediaTypeId": dataForm.newMediaTypeId,
            "name": dataForm.name,
            "mainDeptId": dataForm.mainDeptId,
            "recordTable": this.state.recordTable ? JSON.stringify(this.state.recordTable) : "",
            "status": this.state.status,
            "createById": this.state.createById ? this.state.createById : window.top.currentUser.id,
            "createByName": this.state.createByName,
            "createDeptIds": this.state.createDeptIds,
            "statusName": this.state.statusName,
            "uuid": this.state.uuid,
            "processType": this.state.processType,
            "createTime": this.state.createTime,
            "updateTime": this.state.updateTime,
            "ext": newFieldList

        };
        if (this.state.id !== undefined && this.state.id !== null) {
            body.id = this.state.id;
        }
        if (this.state._id) {
            body._id = this.state._id;
        }
        if (this.state.code) {
            body.code = this.state.code;
        }
        //新增媒体
        if (this.state.id !== undefined && this.state.id !== null) {
            batchAddUpdateSimple(body, (data) => {
                if (data.length > 0) {
                    message.success("修改成功");
                    this.props.saveAfterExitChange();
                    this.setState({visible: false});
                } else {
                    message.error('修改失败！');
                }
                this.props.getTempBatchAdd();
                this.props.simpleAddOrEditChange();
            })
        } else {
            batchAddSimpleAdd(body, (data) => {
                if (data.length > 0) {
                    message.success("添加成功");
                    this.props.saveAfterExitChange();
                    this.setState({visible: false});
                } else {
                    message.error('添加失败！');
                }
                this.props.getTempBatchAdd();
                this.props.simpleAddOrEditChange();
            })
        }
    }

    /**
     * 流程初始化前，调用的方法，
     * @param activiti
     */
    beforeEveryOneStartActiviti(uuid) {
        let mediaInfo = this.state.uuid2auditData[uuid];
        this.copyData2State(mediaInfo)
    }

    copyData2State(mediaInfo) {
        this.state.id = mediaInfo.id;
        this.state._id = mediaInfo._id;
        this.state.logo = mediaInfo.logo;//媒体logo
        this.state.name = mediaInfo.name;//媒体名称
        this.state.newMediaTypeId = mediaInfo.newMediaTypeId;//媒体平台
        this.state.mainDeptId = mediaInfo.mainDeptId;//主责单位
        this.state.status = mediaInfo.status;//备案状态
        this.state.recordTable = mediaInfo.recordTable ? JSON.parse(mediaInfo.recordTable) : {};//备案表
        this.state.processType = mediaInfo.processType;
        this.state.code = mediaInfo.code;
        this.state.uuid = mediaInfo.uuid;
        this.state.createById = mediaInfo.createById;
        this.state.currentMedia = mediaInfo;
        this.state.mediaInfo = mediaInfo;
        this.state.statusName = mediaInfo.statusName;
        this.state.fieldList = mediaInfo.ext;

    }

    verify(item) {
        let reg = /^[\d-]+$/;
        let verifyType = 0;
        if (!item.mainDeptId || !item.name) {
            verifyType = 1
            return verifyType;
        }
        for (var j = 0; j < item.ext.length; j++) {
            let fieldListItem = item.ext[j];
            let dbFieldName = fieldListItem.dbFieldName;
            if (fieldListItem.status && fieldListItem.required === 0 && !fieldListItem.value) {
                verifyType = 1
                return verifyType;
            }
            if (fieldListItem.status && fieldListItem.required === 0 && dbFieldName === "contact" && fieldListItem.value && (!reg.test(fieldListItem.value))) {
                verifyType = 2
                return verifyType;
            }
        }
        return verifyType;
    }

    batchTask(item, myMedia) {
        //批量审核
        let param = {};
        let checkItem = myMedia.props.batchData;
        let checkedArr = [];
        if (myMedia.props.batchTitle === "批量新增") {
            for (let i = 0; i < checkItem.length; i++) {
                param[checkItem[i].uuid] = checkItem[i];
                checkedArr.push(checkItem[i]);
                //校验
                let verifyType = myMedia.verify(checkItem[i]);
                if (verifyType) {
                    if (verifyType === 1) {
                        message.warn(`请检查”${checkItem[i].name}“的必填项！`);
                    } else if (verifyType === 2) {
                        message.error(`”${checkItem[i].name}“联系电话格式不正确！`);
                    }
                    return;
                }
                //批量新增维护字段处理
                let newFieldList = [];
                if (checkItem[i].ext && checkItem[i].ext.length > 0) {
                    checkItem[i].ext.forEach(extItem => {
                        //类型为时间选择器
                        let val = extItem.value ? extItem.value : "";
                        if (extItem.fieldType === 5) {
                            if (val) {
                                val = extItem.value.valueOf();
                            } else {
                                val = null;
                            }
                        }
                        newFieldList.push({
                            newMediaFieldDefineId: extItem.id,
                            value: val
                        });
                    });
                }
                checkItem[i].ext = newFieldList;
            }
            //批量保存每条数据
            checkItem.forEach(item => {
                let body = {...item};
                batchAddUpdateSimple(body, (data) => {
                    if (data.length > 0) {
                        myMedia.props.batchSaveAfterEdit();
                    }
                })
            })
        } else {
            if (checkItem.every(item => item.checked === false)) {
                message.warn("请选择需要批量审核的数据！");
                return;
            }
            for (let i = 0; i < checkItem.length; i++) {
                if (checkItem[i].checked) {
                    param[checkItem[i].uuid] = checkItem[i];
                    checkedArr.push(checkItem[i]);
                }
            }
        }
        myMedia.state.uuid2auditData = param;

        //重置步数，
        let step = checkedArr.length;
        let percent = 0;
        myMedia.setState({
            step,
            percent
        });
        let dealCount = 0;
        let failCount = 0;
        let failInfo = "";
        this.batchStart(param, this.options, this, item, myMedia.beforeEveryOneStartActiviti.bind(myMedia), function (msgRes) {
            if (msgRes) {
                if (item.btnName !== "审核不通过" && item.btnName !== "返回修改" && myMedia.props.batchData.length > 0) {
                    myMedia.state.stepVisible = true;
                }
                //设置进度条，
                dealCount++;
                if (msgRes.code === -1) {
                    failCount++;
                    failInfo += myMedia.state.uuid2auditData[msgRes.uuid].name + ";";
                }

                let percent = Math.ceil((dealCount / step) * 100);
                myMedia.setState({
                    percent
                });

            } else {
                console.log("error")
            }
        }, function (resRes) {
            if (resRes && resRes.code === 1) {
                myMedia.setState({
                    stepVisible: false
                });
                window.loading.hide();
                let text = "审核";
                if (myMedia.props.batchTitle === "批量新增") {
                    text = "新增";
                }
                let content = "总共" + text + step + "条，操作成功" + (step - failCount) + "条,操作失败" + failCount + '条'
                if (failInfo) {
                    content += "{" + failInfo + "}";
                }
                if (myMedia.props.batchTitle !== "批量新增") {
                    myMedia.setState({
                        auditSuccessVisible: true,
                        auditSuccessContent: content
                    })
                } else {
                    confirm({
                        title: myMedia.props.batchTitle === "批量新增" ? "批量新增成功" : "批量审核成功",
                        content: myMedia.props.batchTitle + "已完成，" + content,
                        centered: 'centered',
                        cancelText: "返回",
                        okText: "确定",
                        onCancel() {
                            if (myMedia.props.batchTitle === "批量新增") {
                                myMedia.overTask();
                                cancelExport({}, (res) => {})
                            }
                            myMedia.props.goBack();
                        },
                        onOk() {
                            myMedia.overTask(() => {
                                myMedia.props.getTempBatchAdd();  //先调用remove再调用taskList
                            });
                            myMedia.props.simpleAddOrEditChange();
                        }
                    });
                }
            } else {
                confirm({
                    title: "审核失败",
                    content: "审核失败，请联系系统管理员",
                    centered: 'centered',
                    cancelText: "返回",
                    onCancel() {
                        if (myMedia.props.batchTitle === "批量新增") {
                            myMedia.overTask();
                        }
                    }
                });
            }
        })
    }

    overTask(callback) {
        getOverTask({}, (data) => {
            if (callback) {
                callback();
            }
        })
    }

    callBatchAuditSuccess() {
        //刷新列表
        this.state.auditSuccessVisible = false;
        this.props.getNeedAuditMedia((batchData) => {
            if (batchData.length > 0) {
                this.props.initProcessOperate(batchData);
            }
        });
        this.revert();
    }

    //修改信息
    updateInfo() {
        this.setState({
            isUpdateInfo: false,
            isShowRemarks: false
        }, () => {
            this.initNewMediaAct(this.state.currentMedia);
        })
    }

    //取消修改
    cancelUpdateInfo = () => {
        this.setState({
            isUpdateInfo: true,
            isShowRemarks: false
        }, () => {
            this.init(this.state.currentMedia);
        });
    }

    //审核记录的数据
    auditRecordData() {
        getActHistory({bizKey: this.state.uuid}, (data) => {
            if (data && data.length > 0) {
                data.reverse();
                let _arr = JSON.parse(JSON.stringify(data));
                let newArr = [];
                if (_arr.some(item => item.done)) {
                    while (_arr.findIndex(item => item.done) >= 0) {
                        let index = _arr.findIndex(item => item.done)
                        let arr = _arr.splice(0, index + 1)
                        newArr.push(arr);
                    }
                    if (_arr && _arr.length) {
                        newArr.push(_arr);
                    }
                } else {
                    newArr.push(_arr)
                }
                let newData = [];
                newArr.forEach((item1, index1) => {
                    let operation = [];
                    //第一项记录是它本身
                    if (index1 === 0) {
                        operation = JSON.parse(JSON.stringify(item1));
                    }
                    if (index1 > 0) {
                        if (newArr[index1 - 1].length > 0) {
                            //取前一条记录的最后一项
                            operation.push(newArr[index1 - 1][newArr[index1 - 1].length - 1])
                        }
                        //把前一条的最后一项和当前的合并
                        operation = [...operation, ...JSON.parse(JSON.stringify(item1))];
                    }
                    //前后补齐字段，赋空，为了解决空值时对比不出修改记录
                    operation.forEach((itemOperation,indexOperation)=>{
                        if(indexOperation > 0){
                            let update = JSON.parse(JSON.stringify(operation[indexOperation - 1]));
                            let current = JSON.parse(JSON.stringify(itemOperation));
                            //取出前后两条数据中的ext，并取出标识值(dbFieldName)
                            let updateExtArr = update.processData.data.ext;
                            let currentExtArr = current.processData.data.ext;
                            let updateExtArrKeys = [];
                            let currentExtArrKeys = [];
                            updateExtArr.forEach(updateExtArrItem=>{
                                updateExtArrKeys.push(updateExtArrItem.dbFieldName);
                            })
                            currentExtArr.forEach(currentExtArrItem=>{
                                currentExtArrKeys.push(currentExtArrItem.dbFieldName);
                            })
                            //彼此互补数据使value赋空值
                            updateExtArrKeys.forEach(updateKeysItem => {
                                if (currentExtArrKeys.indexOf(updateKeysItem) === -1) {
                                    let currFindItem = updateExtArr.find(findItem => findItem.dbFieldName === updateKeysItem);
                                    let newCurrFindItem = JSON.parse(JSON.stringify(currFindItem));
                                    newCurrFindItem.value = "";   //赋值操作需要复制数据
                                    currentExtArr.push(newCurrFindItem);
                                }
                            })
                            currentExtArrKeys.forEach((currentKeysItem) => {
                                if (updateExtArrKeys.indexOf(currentKeysItem) === -1) {
                                    let currFindItem = currentExtArr.find(findItem => findItem.dbFieldName === currentKeysItem);
                                    let newCurrFindItem = JSON.parse(JSON.stringify(currFindItem));
                                    newCurrFindItem.value = "";   //赋值操作需要复制数据
                                    updateExtArr.push(newCurrFindItem);
                                }
                            })
                            //复制的数据最后需要重新赋值
                            operation[indexOperation - 1] = update;
                            operation[indexOperation] = current;
                        }
                    })

                    newData.push({
                        key: index1,
                        history: JSON.parse(JSON.stringify(item1)),
                        operation: operation
                    })
                })
                this.newAddMedia.state.record = true;
                this.setState({auditRecordData: newData})
            } else {
                this.newAddMedia.state.record = true;
                this.setState({auditRecordData: []})
            }
        }, {
            info: (info) => {
                message.error("暂无审核记录！");
            }
        })
    }

    //打开新增或详情弹窗
    openModal() {
        this.setState({
            visible: true
        });
    }

    //重置
    revert() {
        this.setState({
            logo: "",  //logo
            newMediaTypeId: undefined,  //媒体平台
            id: null,
            _id: "",
            name: "",  //媒体名称
            mainDeptId: undefined,  //主责单位
            selectSearchValue: "",
            recordTable: {}, //备案表url
            statusName: "", //媒体状态
            isUpdateInfo: false,
            processType: 0,
            uuid2auditData: {},
            code: '',
            uuid: "",
            fieldList: [],
            status: "未备案",
            isShowRemarks: true,
            createTime: "",
            updateTime: "",
            activityRemark: ""
        });
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        let dataForm = this.props.form.getFieldsValue();
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
            </div>
        );
        const recordListProps = {
            name: 'file',
            accept: "." + [...PIC_TYPE_PDF].join(",."),
            showUploadList: false,
            beforeUpload: file => {
                const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/bmp' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'application/pdf';
                let fileName = file.name;
                if (!isJpgOrPng) {
                    message.error('暂不支持该文件类型！');
                }
                // const isLt2M = file.size / 1024 < 200;
                // if (!isLt2M) {
                //     message.error('图片大小必须小于200KB!');
                //     return ;
                // }
                return isJpgOrPng && fileName;
            },
            customRequest: ({file}) => {
                let url = "/storage/uploadFile";
                let fd = new FormData();
                fd.append("file", file);
                this.request({
                    url, body: fd, method: "post", contentType: "upload", callBack: (fileInfo) => {
                        let that = this;
                        if (fileInfo) {
                            that.state.recordTable = fileInfo ? fileInfo : null;
                            message.success("上传备案表成功");
                            that.setState({
                                loading: false,
                            })
                        } else {
                            message.error("上传备案表失败！");
                        }
                    }, errorCallBack: () => {

                    }, serverVerify: {
                        serverErrorCallBack: () => {

                        }
                    }
                });
            }
        };
        return (
            <div id={"newMediaAdd"}>
                <Modal
                    title={this.props.title}
                    visible={this.state.visible}
                    onOk={() => {
                        this.saveMedia();
                    }}
                    onCancel={() => {
                        this.state.visible = false;
                        this.state.isShowRemarks = true;
                        if (this.props.showCurrentPageType === "batchPage") {
                            this.props.simpleAddOrEditChange();
                        }
                        this.setState({});
                    }}
                    zIndex={1000}
                    maskClosable={false}
                    width={1000}
                    centered
                    destroyOnClose
                    footer={
                        <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <div style={{display: (this.state.activityRemark && (this.state.statusName.indexOf("审核不通过") > -1 || this.state.statusName.indexOf("返回") > -1)) ? "block" : "none", marginRight: "10px"}}>
                                <Button onClick={() => {
                                    Modal.info({title: this.state.activityRemark});
                                }}>查看备注</Button>
                            </div>
                            <div>
                                {this.state.buttons}
                            </div>
                        </div>
                    }
                >
                    <div style={{padding: "0px 10px"}} id={"newMediaAdd"}>
                        <Scrollbars autoHeight autoHeightMax={650} autoHide onScroll={() => {
                            this.setState({
                                key: uuid()
                            })
                        }}>
                            <Form name="nest-messages" className={'filedList'}>
                                <Row>
                                    <div style={{padding: "0px 10px", display: "flex", alignItems: "center",}}
                                         id={"newAddUpload"}>
                                        <Col span={2} style={{marginTop: "14px"}}>
                                            <Upload
                                                name="file"
                                                listType="picture-card"
                                                className="avatar-uploader"
                                                showUploadList={false}
                                                accept={"." + [...PIC_TYPE_PDF].join(",.")}
                                                beforeUpload={(file) => {
                                                    const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/bmp' || file.type === 'image/png' || file.type === 'image/gif';
                                                    let fileName = file.name;
                                                    if (!isJpgOrPng) {
                                                        message.error('只能上传JPG、jpeg、bmp、png、gif文件！');
                                                    }
                                                    return isJpgOrPng && fileName;
                                                }}
                                                customRequest={({file}) => {
                                                    let url = "/storage/uploadFile";
                                                    let fd = new FormData();
                                                    fd.append("file", file);
                                                    this.request({
                                                        url,
                                                        body: fd,
                                                        method: "post",
                                                        contentType: "upload",
                                                        callBack: (file) => {
                                                            let that = this;
                                                            if (file) {
                                                                let logo = file.smallPath ? file.smallPath : null;
                                                                that.setState({
                                                                    logo,
                                                                    loading: false,
                                                                })
                                                            }
                                                        },
                                                        errorCallBack: () => {

                                                        },
                                                        serverVerify: {
                                                            serverErrorCallBack: () => {

                                                            }
                                                        }
                                                    });
                                                }}
                                                disabled={this.state.isUpdateInfo}
                                            >
                                                {getFieldDecorator('logo', {
                                                    initialValue: this.state.logo
                                                })(
                                                    <div>
                                                        {
                                                            this.state.logo ?
                                                                <img src={this.state.logo} alt="avatar" style={{
                                                                    width: '56px',
                                                                    height: '56px',
                                                                    lineHeight: "52px",
                                                                    borderRadius: "50%",
                                                                    objectFit: 'cover'
                                                                }}/> : uploadButton
                                                        }
                                                    </div>
                                                )}
                                            </Upload>
                                            <style>{`
                                            #newMediaAdd .ant-upload.ant-upload-select-picture-card{width:56px;height:56px;line-height: 52px;}
                                            #newMediaAdd .ant-upload.ant-upload-select-picture-card > .ant-upload{padding: 0;}
                                            #newMediaAdd .ant-upload.ant-upload-select-picture-card #logo{width:56px;height:56px;line-height: 52px;border-radius: 50%;
                                                            background: rgba(0,80,179,0.0800);}
                                                        .avatar-uploader .anticon svg{width: 30px;height: 30px;margin-top: 13px; color: #0050B3;}
                                            `}</style>
                                        </Col>
                                        <Col
                                            style={{display: !this.state.logo && !this.state.statusName ? "block" : "none"}}
                                            span={2}>上传Logo</Col>
                                        <Col span={1}/>
                                        <Col style={{display: this.state.statusName ? "block" : "none"}}
                                             span={6}>
                                            <div>媒体状态： {this.state.statusName === "已备案" ? "审核通过" : this.state.statusName}</div>
                                            <div
                                                style={{display: this.state.lastActiveTime ? "block" : "none"}}>最近活跃： {this.state.lastActiveTime ? formatDate(this.state.lastActiveTime) : null}</div>
                                        </Col>
                                        <Col
                                            span={(!this.state.logo && !this.state.statusName) ? 7 : this.state.statusName ? 3 : 9}/>
                                        <Col span={11}>
                                            <Form.Item label="媒体平台">
                                                {getFieldDecorator('newMediaTypeId', {
                                                    initialValue: this.state.newMediaTypeId,
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: '请输入媒体平台'
                                                        },
                                                    ],
                                                })(
                                                    <Select
                                                        key={this.state.key}
                                                        placeholder={"请选择"}
                                                        className={'myMediaContent'}
                                                        style={{width: '100%', height: "30px"}}
                                                        disabled={this.state.isUpdateInfo}
                                                        onChange={(e) => {
                                                            this.props.mediaPlatform.forEach(item => {
                                                                if (item.id === e) {
                                                                    this.state.logo = item.logoPath ? item.logoPath : "";
                                                                }
                                                            })
                                                            this.setState({newMediaTypeId: e}, () => {
                                                                this.getNewMediaFields();  //调维护字段接口获取自定义字段数据
                                                            });
                                                        }}>
                                                        {
                                                            this.props.mediaPlatform.map((mediaPlatformItem, mediaPlatformIndex) => {
                                                                return (
                                                                    <Option key={mediaPlatformIndex}
                                                                            value={mediaPlatformItem.id}
                                                                    >
                                                                    <span style={{
                                                                        verticalAlign: "middle",
                                                                        marginRight: "5px"
                                                                    }}>{mediaPlatformItem.name}</span>
                                                                        {
                                                                            mediaPlatformItem.logoPath ?
                                                                                <img src={mediaPlatformItem.logoPath}
                                                                                     alt=""
                                                                                     style={{
                                                                                         width: 18,
                                                                                         height: 18,
                                                                                         borderRadius: "50%",
                                                                                         objectFit: "cover"
                                                                                     }}/> : null
                                                                        }
                                                                    </Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </div>
                                </Row>
                                <Row>
                                    <div style={{padding: "6px 10px"}}>
                                        <Col span={11}>
                                            <div style={{display: "flex"}}>
                                                <Form.Item hasFeedback label="媒体名称">
                                                    {getFieldDecorator('name', {
                                                        initialValue: this.state.name,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: '请输入媒体名称'
                                                            },
                                                            {
                                                                min: 1, max: 40,
                                                                message: '内容不能超过40个字'
                                                            }
                                                        ],
                                                    })(
                                                        <Input placeholder="请输入"
                                                               disabled={this.state.isUpdateInfo}
                                                               style={{width: 320, background: "#F6F8FD"}}
                                                        />
                                                    )}
                                                </Form.Item>
                                                {
                                                    (() => {
                                                        let specialMedia = ["公众号", "微博"];
                                                        return (this.props.mediaPlatform.length && dataForm.newMediaTypeId && this.props.mediaPlatform.filter(item => specialMedia.indexOf(item.name) !== -1).map(item => item.id).includes(dataForm.newMediaTypeId) ?
                                                            <div style={{
                                                                display: "inline",
                                                                marginTop: 44,
                                                                marginLeft: 10
                                                            }}>
                                                                <Button type="primary"
                                                                        disabled={this.state.isUpdateInfo}
                                                                        onClick={() => this.verifyName()}>验证名称</Button>
                                                            </div>
                                                            : <div style={{
                                                                display: "inline",
                                                                marginTop: 44,
                                                                marginLeft: 10
                                                            }}>
                                                                <Tooltip placement={"bottom"}
                                                                         title={`只有${specialMedia.join("，")}类型的媒体才能验证名称`}><Button
                                                                    disabled>验证名称</Button></Tooltip>
                                                            </div>)
                                                    })()
                                                }
                                            </div>
                                        </Col>
                                        <Col span={1}/>
                                        <Col span={11}>
                                            <div style={{
                                                lineHeight: "40px",
                                                height: "40px",
                                                fontSize: "14px",
                                                color: "rgba(0, 0, 0, 0.85)"
                                            }}>备案表
                                                {/*<span*/}
                                                {/*style={{*/}
                                                {/*    color: "red",*/}
                                                {/*    fontSize: 12*/}
                                                {/*}}>（支持常见图片格式（jpg、jpeg、bmp、png、gif）及pdf格式）</span>*/}
                                            </div>
                                            {
                                                this.state.recordTable && this.state.recordTable.path ?
                                                    <div style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        paddingTop: "3px"
                                                    }}>
                                                        <a title={this.state.recordTable.name} style={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            lineClamp: 1,
                                                            whiteSpace: "nowrap",
                                                            maxLength: 17,
                                                            fontSize: 14
                                                        }} onClick={() => {
                                                            let file = this.state.recordTable;
                                                            this.setState({
                                                                imgPath: file.path,
                                                                viewImgVisible: true
                                                            })
                                                        }}>{this.state.recordTable.name}</a>
                                                        <Button style={{
                                                            marginRight: "16px",
                                                            marginLeft: 5,
                                                            background: "#fff",
                                                            border: "1px solid rgba(0, 0, 0, 0.15)"
                                                        }}
                                                                disabled={this.state.isUpdateInfo}
                                                                onClick={() => {
                                                                    this.state.recordTable.path = ""
                                                                    this.setState({})
                                                                }}>删除</Button>
                                                        <Upload {...recordListProps}>
                                                            <Button style={{
                                                                background: "#fff",
                                                                border: "1px solid rgba(0, 0, 0, 0.15)"
                                                            }}
                                                                    disabled={this.state.isUpdateInfo}>重新上传</Button>
                                                        </Upload>
                                                    </div>
                                                    :
                                                    <div style={{paddingTop: "3px"}}>
                                                        <Upload {...recordListProps}>
                                                            <Button style={{background: "#F6F8FD"}}
                                                                    disabled={this.state.isUpdateInfo}><Icon
                                                                type="upload"/>上传备案表</Button>
                                                        </Upload>
                                                    </div>
                                            }
                                        </Col>
                                    </div>
                                </Row>
                                <Row>
                                    <div style={{padding: "6px 10px"}} id={"mainDept"}>
                                        <Col span={11}>
                                            <Form.Item label="主责单位">
                                                {getFieldDecorator('mainDeptId', {
                                                    initialValue: this.state.mainDeptId,
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: '请输入主责单位'
                                                        },
                                                    ],
                                                })(
                                                    <Select
                                                        key={this.state.key}
                                                        disabled={this.state.isUpdateInfo}
                                                        placeholder={"请选择"}
                                                        showSearch
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        notFoundContent={null}
                                                        onSearch={this.handleSearch}
                                                        onChange={(e) => {
                                                            this.state.mainDeptId = e;
                                                            this.state.selectSearchValue = "";
                                                            this.setState({})
                                                        }}
                                                        className={'myMediaContent'}
                                                        style={{width: '100%', height: "30px"}}
                                                    >
                                                        {this.props.mainDutyDept.map((item, i) => {
                                                            let showOption = true;
                                                            if (this.state.selectSearchValue) {
                                                                showOption = item.name.indexOf(this.state.selectSearchValue) > -1;
                                                            }
                                                            return (
                                                                <Option key={i} value={item.id}
                                                                        style={{display: showOption ? 'block' : 'none'}}>{item.name}</Option>
                                                            )
                                                        })
                                                        }
                                                    </Select>
                                                )}
                                            </Form.Item>
                                            <style>{`#mainDept .ant-select-selection__placeholder{padding-left: 3px;}`}</style>
                                        </Col>
                                        <Col span={1}></Col>
                                        <Col span={11}>
                                            <div style={{
                                                lineHeight: "40px",
                                                height: "40px",
                                                fontSize: "14px",
                                                color: "rgba(0, 0, 0, 0.85)"
                                            }}>备案状态
                                            </div>
                                            <div style={{color: this.state.status === "已备案" ? "#008000" : "#FF1313"}}>
                                                {this.state.status ? this.state.status : "未备案"}
                                            </div>
                                        </Col>
                                    </div>
                                </Row>

                                {/*************************************维护字段***************************************/}
                                <div>
                                    <style>
                                        {
                                            `
                                             .filedList .ant-row{position:initial !important }
                                            `
                                        }
                                    </style>
                                    <div style={{
                                        padding: "6px 10px",
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        flexWrap: 'wrap'
                                    }}>
                                        {
                                            this.state.fieldList && this.state.fieldList.length > 0 && this.state.fieldList.map((item, index) => {
                                                if (!item.fieldName) {
                                                    return <div></div>;
                                                }
                                                if (item.fieldType === 1) {
                                                    let len; //限制字符数
                                                    let reg;  //正则表达式
                                                    let content; //校验提示内容
                                                    let contentArry = []; //限制内容数组
                                                    item.fieldFillRules.map((fieldTypeItem, fieldTypeIndex) => {
                                                        if (fieldTypeItem.ruleType === 0) {
                                                            len = fieldTypeItem.length; //字符数长度
                                                        }
                                                        contentArry = fieldTypeItem.contentTypes ? fieldTypeItem.contentTypes : [];
                                                        if (fieldTypeItem.ruleType === 1) {
                                                            contentArry.map(typeItem => {
                                                                if (typeItem === 0) { //字母
                                                                    reg = /[a-zA-Z]/;
                                                                    content = "内容只能输入字母"
                                                                }
                                                                if (typeItem === 1) { //数字
                                                                    reg = /[0-9]/;
                                                                    content = "内容只能输入数字"
                                                                }
                                                                if (typeItem === 2) { //中文
                                                                    reg = /[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]/;
                                                                    content = "内容只能输入中文"
                                                                }
                                                                if (typeItem == 0 && typeItem == 1) { //字母和数字
                                                                    reg = /^[a-zA-Z0-9]+$/;
                                                                    content = "内容只能输入字母和数字"
                                                                }
                                                                if (typeItem == 0 && typeItem == 2) { //字母和中文
                                                                    reg = /^[a-zA-Z\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]+$/;
                                                                    content = "内容只能输入中文和字母"
                                                                }
                                                                if (typeItem == 1 && typeItem == 2) { //数字和中文
                                                                    reg = /^[0-9\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]+$/;
                                                                    content = "内容只能输入中文和数字"
                                                                }
                                                                if (contentArry.length > 2) { //字母、数字、中文
                                                                    reg = /^[a-zA-Z0-9\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]+$/;
                                                                    content = "内容只能输入中文、字母和数字"
                                                                }
                                                            })
                                                        }
                                                    })
                                                    let verify = /^[\d-]+$/;
                                                    return (
                                                        <Form.Item hasFeedback key={item.id} style={{
                                                            width: '50%',
                                                            display: item.status ? "block" : "none"
                                                        }}
                                                                   label={item.status === 1 ?
                                                                       <span>{item.fieldName}
                                                                           <Tooltip placement="top"
                                                                                    title={item.fieldTip}>
                                                                           <span
                                                                               style={{
                                                                                   display: item.fieldTip ? "inline-block" : "none",
                                                                                   marginLeft: 10,
                                                                                   cursor: 'pointer'
                                                                               }}><Icon type="question-circle"/></span></Tooltip>
                                                                           </span> : ""}
                                                        >
                                                            {
                                                                item.status === 1 ?
                                                                        getFieldDecorator(item.id, {
                                                                            initialValue: item.value,
                                                                            rules: [
                                                                                {
                                                                                    required: item.required === 0 ? true : false,
                                                                                    message: `请输入${item.fieldName}`,
                                                                                },
                                                                                len > 0 ? {
                                                                                    min: 1, max: len,
                                                                                    message: `内容不能超过${len}个字`
                                                                                } : {},
                                                                                contentArry.length > 0 ? {
                                                                                    pattern: reg,
                                                                                    message: content,
                                                                                } : {},
                                                                                item.dbFieldName === "contact" ? {
                                                                                    pattern: verify,
                                                                                    message: `${item.fieldName}格式不正确`,
                                                                                } : {}
                                                                            ],
                                                                        })(
                                                                            <Input
                                                                                placeholder="请输入"
                                                                                disabled={this.state.isUpdateInfo}
                                                                                style={{
                                                                                    width: item.dbFieldName === "link" ? 320 : 418,
                                                                                    background: "#F6F8FD",
                                                                                    marginBottom: 15
                                                                                }}
                                                                            />
                                                                        )
                                                                   : null
                                                            }
                                                            {
                                                                item.dbFieldName === "link" ?
                                                                    <span style={{
                                                                        marginRight: 30,
                                                                        float: 'right',
                                                                    }}>
                                                                        {/*{*/}
                                                                        {/*    (item.value || dataForm[item.id]) ?*/}
                                                                        {/*        <Button type={"primary"}*/}
                                                                        {/*                disabled={this.state.isUpdateInfo}*/}
                                                                        {/*                onClick={() => this.verifyLink(item)}>验证链接</Button> :*/}
                                                                        {/*        <Button*/}
                                                                        {/*            disabled>验证链接</Button>*/}
                                                                        {/*}*/}
                                                                        <span style={{cursor: "pointer"}}
                                                                             onClick={() => this.getLink()}>链接如何获取？
                                                                        </span>
                                                                    </span> : null
                                                            }
                                                        </Form.Item>
                                                    )
                                                }
                                                if (item.fieldType === 2) {
                                                    let reg;  //正则表达式
                                                    let content; //校验提示内容
                                                    let contentArry = []; //限制内容数组
                                                    item.fieldFillRules.map((fieldTypeItem, fieldTypeIndex) => {
                                                        if (fieldTypeItem.ruleType === 0) {
                                                            item.len = fieldTypeItem.length; //字符数长度
                                                        }
                                                        contentArry = fieldTypeItem.contentTypes ? fieldTypeItem.contentTypes : [];
                                                        if (fieldTypeItem.ruleType === 1) {
                                                            contentArry.map(typeItem => {
                                                                if (typeItem === 0) { //字母
                                                                    reg = /[a-zA-Z]/;
                                                                    content = "内容只能输入字母"
                                                                }
                                                                if (typeItem === 1) { //数字
                                                                    reg = /[0-9]/;
                                                                    content = "内容只能输入数字"
                                                                }
                                                                if (typeItem === 2) { //中文
                                                                    reg = /[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]/;
                                                                    content = "内容只能输入中文"
                                                                }
                                                                if (typeItem == 0 && typeItem == 1) { //字母和数字
                                                                    reg = /^[a-zA-Z0-9]+$/;
                                                                    content = "内容只能输入字母和数字"
                                                                }
                                                                if (typeItem == 0 && typeItem == 2) { //字母和中文
                                                                    reg = /^[a-zA-Z\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]+$/;
                                                                    content = "内容只能输入中文和字母"
                                                                }
                                                                if (typeItem == 1 && typeItem == 2) { //数字和中文
                                                                    reg = /^[0-9\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]+$/;
                                                                    content = "内容只能输入中文和数字"
                                                                }
                                                                if (contentArry.length > 2) { //字母、数字、中文
                                                                    reg = /^[a-zA-Z0-9\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]+$/;
                                                                    content = "内容只能输入中文、字母和数字"
                                                                }
                                                            })
                                                        }
                                                    })
                                                    return (
                                                        <Form.Item key={item.id} style={{
                                                            paddingRight: item.status ? "16px" : 0
                                                        }}
                                                                   label={item.status === 1 ? <span>{item.fieldName}
                                                                       <Tooltip placement="top"
                                                                                title={item.fieldTip}>
                                                                           <span
                                                                               style={{
                                                                                   display: item.fieldTip ? "inline-block" : "none",
                                                                                   marginLeft: 10,
                                                                                   cursor: 'pointer'
                                                                               }}><Icon type="question-circle"/></span></Tooltip>
                                                                           </span> : ""}>
                                                            {
                                                                item.status === 1 ?
                                                                    <div>
                                                                        {getFieldDecorator(item.id, {
                                                                            initialValue: item.value,
                                                                            rules: [
                                                                                {
                                                                                    required: item.required === 0 ? true : false,
                                                                                    message: item.required === 0 || item.value === "" ?
                                                                                        <div>{`请输入${item.fieldName}`}</div> : "",
                                                                                },
                                                                                item.len > 0 ? {
                                                                                    min: 1, max: item.len,
                                                                                    message: `内容不能超过${item.len}个字`
                                                                                } : {},
                                                                                contentArry.length > 0 ? {
                                                                                    pattern: reg,
                                                                                    message: content,
                                                                                } : {}
                                                                            ],
                                                                        })(
                                                                            <TextArea
                                                                                placeholder="请输入"
                                                                                rows={4}
                                                                                maxLength={500}
                                                                                style={{
                                                                                    background: "#F6F8FD",
                                                                                    width: 875,
                                                                                    marginRight: 20,
                                                                                    marginBottom: 15,
                                                                                    resize: "none"  //去掉拖动属性
                                                                                }}
                                                                                disabled={this.state.isUpdateInfo}
                                                                            />
                                                                        )}
                                                                    </div> : ""
                                                            }
                                                        </Form.Item>
                                                    )
                                                }
                                                if (item.fieldType === 3) {
                                                    let array = [];  //定义数组组装成key，value形式
                                                    item.fieldFillRules.map((fieldTypeItem, fieldTypeIndex) => {
                                                        let list = fieldTypeItem.keyValueMaps;  //自定义字段下拉框的值
                                                        for (let i in list) {
                                                            array.push(
                                                                {
                                                                    key: i,
                                                                    val: list[i]
                                                                }
                                                            )
                                                        }
                                                    })
                                                    return (
                                                        <Form.Item key={item.id} style={{
                                                            width: '50%',
                                                            display: item.status ? "block" : "none",
                                                            paddingRight: item.status ? "16px" : 0
                                                        }}
                                                                   label={item.status === 1 ? <span>{item.fieldName}
                                                                       <Tooltip placement="top"
                                                                                title={item.fieldTip}>
                                                                           <span
                                                                               style={{
                                                                                   display: item.fieldTip ? "inline-block" : "none",
                                                                                   marginLeft: 10,
                                                                                   cursor: 'pointer'
                                                                               }}><Icon type="question-circle"/></span></Tooltip>
                                                                           </span> : ""}>
                                                            {
                                                                item.status === 1 ?
                                                                    <div>
                                                                        {getFieldDecorator(item.id, {
                                                                            initialValue: item.value,
                                                                            rules: [
                                                                                {
                                                                                    required: item.required === 0 ? true : false,
                                                                                    message: item.required === 0 || item.value === "" ?
                                                                                        <div>{`请选择${item.fieldName}`}</div> : "",
                                                                                }
                                                                            ],
                                                                        })(
                                                                            <Select
                                                                                key={this.state.key}
                                                                                placeholder="请选择"
                                                                                style={{
                                                                                    width: 418,
                                                                                    marginRight: 20,
                                                                                    marginBottom: 15
                                                                                }}
                                                                                disabled={this.state.isUpdateInfo}
                                                                            >
                                                                                {
                                                                                    array.map((keyItem, valueIndex) => {
                                                                                        return (
                                                                                            <Option
                                                                                                value={keyItem.key}
                                                                                                key={valueIndex}>{keyItem.val}</Option>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        )}
                                                                    </div> : ""
                                                            }
                                                        </Form.Item>
                                                    )
                                                }
                                                if (item.fieldType === 4) {
                                                    let array = [];  //定义数组组装成key，value形式
                                                    item.fieldFillRules.map((fieldTypeItem, fieldTypeIndex) => {
                                                        let list = fieldTypeItem.keyValueMaps;  //自定义字段下拉框的值
                                                        for (let i in list) {
                                                            array.push(
                                                                {
                                                                    key: i,
                                                                    val: list[i]
                                                                }
                                                            )
                                                        }
                                                    })
                                                    return (
                                                        <Form.Item key={item.id} style={{
                                                            width: '50%',
                                                            display: item.status ? "block" : "none",
                                                            paddingRight: item.status ? "16px" : 0
                                                        }}
                                                                   label={item.status === 1 ? <span>{item.fieldName}
                                                                       <Tooltip placement="top"
                                                                                title={item.fieldTip}>
                                                                           <span
                                                                               style={{
                                                                                   display: item.fieldTip ? "inline-block" : "none",
                                                                                   marginLeft: 10,
                                                                                   cursor: 'pointer'
                                                                               }}><Icon type="question-circle"/></span></Tooltip>
                                                                           </span> : ""}>
                                                            {
                                                                item.status === 1 ?
                                                                    <div>
                                                                        {getFieldDecorator(item.id, {
                                                                            initialValue: item.value,
                                                                            rules: [
                                                                                {
                                                                                    required: item.required === 0 ? true : false,
                                                                                    message: item.required === 0 || item.value === "" ?
                                                                                        <div>{`请选择${item.fieldName}`}</div> : "",
                                                                                },
                                                                            ],
                                                                        })(
                                                                            <Select
                                                                                key={this.state.key}
                                                                                placeholder="请选择"
                                                                                mode="multiple"
                                                                                style={{
                                                                                    width: 418,
                                                                                    marginRight: 20,
                                                                                    marginBottom: 15
                                                                                }}
                                                                                disabled={this.state.isUpdateInfo}
                                                                            >
                                                                                {
                                                                                    array.map((keyItem, valueIndex) => {
                                                                                        return (
                                                                                            <Option
                                                                                                value={keyItem.key}
                                                                                                key={valueIndex}>{keyItem.val}</Option>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        )}
                                                                    </div> : ""
                                                            }
                                                        </Form.Item>
                                                    )
                                                }
                                                if (item.fieldType === 5) {
                                                    let array = [];  //定义数组组装成key，value形式
                                                    item.fieldFillRules.map((fieldTypeItem, fieldTypeIndex) => {
                                                        let list = fieldTypeItem.keyValueMaps;  //自定义字段下拉框的值
                                                        for (let i in list) {
                                                            array.push(
                                                                {
                                                                    key: i,
                                                                    val: list[i]
                                                                }
                                                            )
                                                        }
                                                    })
                                                    return (
                                                        <Form.Item key={item.id} style={{
                                                            width: '50%',
                                                            display: item.status ? "block" : "none",
                                                            paddingRight: item.status ? "16px" : 0
                                                        }}
                                                                   label={item.status === 1 ? <span>{item.fieldName}
                                                                       <Tooltip placement="top"
                                                                                title={item.fieldTip}>
                                                                           <span
                                                                               style={{
                                                                                   display: item.fieldTip ? "inline-block" : "none",
                                                                                   marginLeft: 10,
                                                                                   cursor: 'pointer'
                                                                               }}><Icon type="question-circle"/></span></Tooltip>
                                                                           </span> : ""}>
                                                            {
                                                                item.status === 1 ?
                                                                    <div>
                                                                        {getFieldDecorator(item.id, {
                                                                            initialValue: item.value ? moment(item.value) : "",
                                                                            rules: [
                                                                                {
                                                                                    required: item.required === 0 ? true : false,
                                                                                    message: item.required === 0 || item.value === null ?
                                                                                        <div>{`请选择${item.fieldName}`}</div> : "",
                                                                                },
                                                                            ],
                                                                        })(
                                                                            <DatePicker
                                                                                format="YYYY-MM-DD"
                                                                                style={{
                                                                                    background: "#F6F8FD",
                                                                                    width: 418,
                                                                                    marginRight: 20,
                                                                                    marginBottom: 15
                                                                                }}
                                                                                disabled={this.state.isUpdateInfo}
                                                                            />
                                                                        )}
                                                                    </div> : ""
                                                            }
                                                        </Form.Item>
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                            </Form>
                        </Scrollbars>
                        <style>{`#newMediaAdd .ant-form-item { margin-bottom: 0px !important;}`}</style>
                    </div>
                </Modal>
                <Modal
                    maskClosable={false}
                    title={this.textareaModalTitle}
                    visible={this.state.textareaModalVisible}
                    zIndex={1000}
                    onOk={this.textareaHandleOk}
                    onCancel={() => {
                        if (this.props.showCurrentPageType === "mainPage") {
                            this.props.getById(this.state.mediaInfo);
                        }
                        this.setState({textareaModalVisible: false, auditRemarks: ''})
                    }}
                >
                    <TextArea maxLength={200} value={this.state.auditRemarks} onChange={(e) => {
                        this.setState({auditRemarks: e.target.value})
                    }} placeholder="请输入备注"/>
                </Modal>
                {/*审核记录组件*/}
                <UpdateAndFlowRecord
                    title={"审核记录"}
                    auditRecordData={this.state.auditRecordData}  //审核记录数据
                    actHistoryData={this.state.actHistoryData}  //流程记录数据
                    onRef={(c) => {
                        this.newAddMedia = c
                    }}
                />
                {/*进度条*/}
                <Modal
                    maskClosable={false}
                    title={"正在提交"}
                    visible={this.state.stepVisible}
                    footer={null}
                    centered={true}
                    closable={false}
                >
                    <Progress percent={this.state.percent} steps={this.state.step} status="active"/>
                    <div>{`正在${this.props.batchTitle}，大约剩余${this.state.step}s`}</div>
                </Modal>
                {/*批量审核成功确认框*/}
                <Modal
                    title={"提示"}
                    maskClosable={false}
                    visible={this.state.auditSuccessVisible}
                    footer={<div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                        <Button onClick={() => {
                            this.props.goBack()
                            this.setState({auditSuccessVisible: false})
                        }}>返回</Button>
                        <Select placeholder={"继续审核"} style={{width: "105px", marginLeft: "10px"}}
                                onSelect={(e) => {
                                    this.callBatchAuditSuccess();
                                    this.props.batchAuditValueChange(e);
                                }}>
                            <Option value={0}>新增</Option>
                            <Option value={1}>更新</Option>
                            <Option value={2}>注销</Option>
                            <Option value={3}>删除</Option>
                        </Select>
                    </div>}
                    centered={true}
                    closable={false}
                >
                    <div>{`${this.props.batchTitle}已完成，${this.state.auditSuccessContent}`}</div>
                </Modal>
                {/*文件预览*/}
                <Modal
                    title={"预览"}
                    maskClosable={false}
                    visible={this.state.viewImgVisible}
                    zIndex={1000}
                    onCancel={() => {
                        this.setState({viewImgVisible: false})
                    }}
                    footer={null}
                >
                    <img src={this.state.imgPath} style={{width: '200px', height: '200px', objectFit: "cover"}}/>
                </Modal>
                <style>{`
                #newMediaAdd .ant-modal-confirm .ant-modal-body{padding: 24px;}
                #newMediaAdd .ant-form-item-label > label::after{content: "";}
                `}</style>
            </div>
        )
    }


    //验证媒体名称
    verifyName() {
        let dataForm = this.props.form.getFieldsValue();
        let body = {
            name: dataForm.name,
            type: dataForm.newMediaTypeId,
        };
        checkName(body, (data, status) => {
            if (data && status === 200) {
                let res = JSON.parse(data);
                Modal.success({
                    content: '媒体名称验证成功！',
                    centered: 'centered',
                    okText: "确定",
                    onOk: () => {
                        this.saveLogo(res)
                    }
                });
            }
        }, {
            info: (info) => {
                Modal.warning({
                    content: '媒体名称验证失败！',
                    centered: 'centered',
                    okText: "确定",
                })
            }
        });
    }

    //验证完媒体名称自动回填logo
    saveLogo(data) {
        let dataForm = this.props.form.getFieldsValue();
        let mediaType = ["公众号", "微博"];
        this.props.mediaPlatform.length && dataForm.newMediaTypeId && this.props.mediaPlatform.filter(item => {
            if (mediaType.indexOf(item.name) > -1 && item.id == dataForm.newMediaTypeId) {
                this.state.logo = item.logoPath;
            }
        });
        this.state.fieldList && this.state.fieldList.length > 0 && this.state.fieldList.forEach(i => {
            if (data[i.dbFieldName]) {
                dataForm[i.id] = data.account;
            }
        })
        this.state.name = data.nickname;
        this.setState({})
        dataForm.name = data.nickname;
        this.props.form.setFieldsValue(dataForm);  //官方文档的原话：“initialValues 不能被 setState 动态更新，你需要用 setFieldsValue 来更新” 。
    }

    //验证链接
    verifyLink(item) {
        let dataForm = this.props.form.getFieldsValue();
        let name = dataForm.name;
        let params = {
            link: dataForm[item.id],
        };
        checkDouyinLink(params, (data, status) => {
            let res;
            if (data) {
                res = JSON.parse(data);
            }
            if ((name && name === res.nickname && status === 200)) {
                Modal.success({
                    title: "验证成功",
                    centered: 'centered',
                    okText: "确定",
                    onOk: () => {
                        let mediaType = ["抖音"];
                        this.props.mediaPlatform.length && dataForm.newMediaTypeId && this.props.mediaPlatform.filter(item => {
                            if (mediaType.indexOf(item.name) > -1 && item.id == dataForm.newMediaTypeId) {
                                this.state.logo = item.logoPath;
                            }
                        });
                        this.state.fieldList && this.state.fieldList.length > 0 && this.state.fieldList.forEach(i => {
                            if (res[i.dbFieldName]) {
                                dataForm[i.id] = res.account;
                            }
                        })
                        this.setState({name: res.nickname})
                        dataForm.name = res.nickname;
                        this.props.form.setFieldsValue(dataForm);
                    }
                });
            }
            if (!name) {
                if (status === 200) {
                    Modal.success({
                        title: "验证成功",
                        content: '恭喜您！抖音链接验证成功！',
                        centered: 'centered',
                        okText: "确定",
                        onOk: () => {
                            let mediaType = ["抖音"];
                            this.props.mediaPlatform.length && dataForm.newMediaTypeId && this.props.mediaPlatform.filter(item => {
                                if (mediaType.indexOf(item.name) > -1 && item.id == dataForm.newMediaTypeId) {
                                    this.state.logo = item.logoPath;
                                }
                            });
                            this.state.fieldList && this.state.fieldList.length > 0 && this.state.fieldList.forEach(i => {
                                if (res[i.dbFieldName]) {
                                    dataForm[i.id] = res.account;
                                }
                            })
                            this.setState({name: res.nickname}) //自动回填媒体名称
                            dataForm.name = res.nickname;
                            this.props.form.setFieldsValue(dataForm);
                        }
                    });
                }
            }
            if (name && status === 200 && name !== res.nickname) {
                Modal.confirm({
                    title: "验证成功",
                    content: '检测到媒体名称与填写内容不一致，请问是否使用获取的名称？',
                    centered: 'centered',
                    okText: "确定",
                    onOk: () => {
                        let mediaType = ["抖音"];
                        this.props.mediaPlatform.length && dataForm.newMediaTypeId && this.props.mediaPlatform.filter(item => {
                            if (mediaType.indexOf(item.name) > -1 && item.id == dataForm.newMediaTypeId) {
                                this.state.logo = item.logoPath;
                            }
                        });
                        this.state.fieldList && this.state.fieldList.length > 0 && this.state.fieldList.forEach(i => {
                            if (res[i.dbFieldName]) {
                                dataForm[i.id] = res.account;
                            }
                        })
                        this.setState({name: res.nickname})
                        dataForm.name = res.nickname;
                        this.props.form.setFieldsValue(dataForm);
                    }
                })
            }

        }, {
            info: (info) => {
                Modal.error({
                    title: "验证失败",
                    content: '请检查链接是否正确！',
                    centered: 'centered',
                    okText: "确定",
                })
            },
            error: (error) => {

            }
        });
    }


    //获取抖音链接方式
    getLink() {
        window.openPage({
            url: "/cm-sites/pms/framereact/index.html#/view/newMediaMatrix/pms/newMediaManagement/douYinLink",
            params: {},
        })
    }

    //获取自定义字段数据
    getNewMediaFields(item, callback) {
        let dataForm;
        let fieldList;
        if (item) {
            dataForm = item;
            fieldList = [];
        } else {
            dataForm = this.props.form.getFieldsValue();
            fieldList = this.state.fieldList;
        }
        if (dataForm.newMediaTypeId) {
            let body = {
                newMediaTypeId: dataForm.newMediaTypeId,
            };
            getNewMediaFields(body, data => {
                    if (item) {
                        data && data.length > 0 && data.forEach(i => {
                            item.ext && item.ext.length > 0 && item.ext.forEach(j => {
                                if (i.id === j.id) {
                                    i.value = j.value;
                                }
                            })
                        })
                        fieldList = data;
                        if (callback) {
                            callback(fieldList);
                        }
                        this.setState({
                            fieldList
                        });
                    } else {
                        fieldList = data;
                        this.setState({
                            fieldList
                        });
                    }
                }
            );
        }
    }

    //上传logo
    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;
        }
        if (info.file.status === 'done') {
            let fileInfo = info.file.response;
            let logo = fileInfo.data ? fileInfo.data.url : null;
            this.setState({
                logo,
                loading: false,
            })
        }
    };

    //主责单位搜索
    handleSearch = value => {
        this.setState({
            selectSearchValue: value,
            mainDeptId: undefined
        })
    };

}

const NewAddMediaForm = Form.create()(NewAddMedia);
export default NewAddMediaForm;

